import _ from 'lodash';
import moment from 'moment';
import { CONSTANT } from './constant';
import { apiHost } from './request';

export const getValue = value => value || '-';

export const setConstant = (constantKey, data, k) => {
  let tempData = _.keyBy(data, k);
  for (let key in tempData) {
    CONSTANT[constantKey][key] = tempData[key].id;
  }
};

export const isEmpty = value => {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  return false;
};

export const hasLength = (...args) => {
  const empty = element => !(element && element.length);
  return !args.every(empty);
};

export const isValidEmail = (email) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
}

export const getFormattedDate = (dateString, format = 'YYYY-MM-DD') => {
  return dateString && moment(dateString).format(format);
};

export const sortedObjects = (arr, name) => arr.sort((a, b) =>
  // eslint-disable-next-line no-nested-ternary
  a[name] > b[name] ? 1 : b[name] > a[name] ? -1 : 0
);

export const getPdfUrl = (id, locale) =>
  `${apiHost}/orders/${id}/quote-pdf?lang=${locale}`;

export const getContractPdfUrl = (id) =>
  `${apiHost}/orders/${id}/contract-pdf?download=true`;
